module.exports = () => {
  return {
    // BASE_URL: '' || '/',
    BASE_URL: '/',
    REDENVELOPE_SERVER_URL: 'https://c4app-preprod-redpacket.carrefour.com.tw/api/' || '',
    APP_SERVER_URL: 'https://c4app-preprod.carrefour.com.tw/c4-user/api/' || '',
    ROUTER: {
      // BASE: '' || '/'
      BASE: '' || '/'
    }
  }
}
